import { FC } from 'react';

interface IGlyphIcon {
  className?: string;
  color?: string;
  onClick?: () => void;
}

const Connecticut: FC<IGlyphIcon> = ({ className = '', onClick, color }) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <g id="Texas">
        <path
          id="fill"
          d="M44.804 54.624L44.676 52.96L44.804 52.832L44.996 52.768L46.148 58.4L44.804 54.624ZM45.508 51.04L44.804 52.64L45.508 50.4L46.404 49.056L45.764 50.4L45.508 51.04ZM46.98 47.776L47.172 47.712V48.16L46.532 49.056L46.98 47.776ZM47.812 47.2L47.172 47.904L47.62 47.2L49.22 46.496L47.812 47.2ZM49.732 45.92L50.116 45.664L49.412 45.984L49.732 45.92ZM56.516 40.736L55.108 42.08L56.196 40.928V40.736H56.516ZM31.876 4L31.94 14.112L33.604 15.072H34.564L34.756 14.816L35.78 15.904L38.212 16.288L38.596 16.864L40.324 16.288L41.156 17.568L42.244 17.056L43.268 17.952L44.292 17.312L44.548 18.336L45.508 17.12L46.148 17.568L46.788 17.312L48.196 18.144L49.924 17.12L50.5 17.312L51.396 16.928L52.356 17.12L52.868 16.544L56.708 18.528L58.244 18.336L58.756 26.592L59.844 27.552V28.64L61.636 31.392L60.676 33.888L61.06 36.512L60.1 37.792L60.484 38.496L59.588 38.752L56.516 40.736L56.708 39.968L57.86 39.52V39.392L56.196 39.712L56.452 38.496L55.876 38.944L55.108 38.752L55.748 40.352L56.196 40.736L54.916 41.568V42.208L53.764 43.36L51.396 44.512V44.576L52.356 44.256L50.116 45.664L51.14 44.576L50.116 45.024L50.5 44.768L50.244 44.512L49.412 44.768L49.22 44.32L49.028 44.256L49.284 44.768L49.22 45.024L48.9 45.344L49.028 44.768L48.196 44.512L48.9 45.536L48.58 45.92L49.22 45.984L48.196 46.56L47.556 45.92L47.62 47.008L47.044 47.584L46.788 47.712L46.98 46.816L46.788 47.712L46.532 47.136L45.764 47.584L45.956 48.352L46.532 47.776L45.764 49.248L44.164 49.056L45.508 50.08L44.676 52.128L44.164 52.32L44.42 51.552L43.844 52.192L43.14 51.296L43.716 52.192L43.14 52.32H44.676L44.164 53.728L44.548 54.24L44.164 54.624L45.508 58.336L46.084 58.4L45.956 58.848L46.148 58.656L46.404 58.976L45.508 59.424L45.38 60L43.908 58.848L41.412 58.72L38.276 57.312L36.996 57.184L36.356 55.072L35.204 53.728L34.884 50.848L33.348 50.08L32.196 48.16L31.236 47.2L29.38 42.784L26.82 40.352L26.308 40.48L25.86 39.392L22.532 39.2L21.764 38.88L21.38 39.392L20.1 39.52L19.332 42.208L17.988 43.68L16.9 43.424L11.972 40.096L9.86 34.784L7.94 33.568L2.756 28L2.5 27.104L18.436 27.744L19.14 4H31.876Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Connecticut;
